import { EDIT_WORK_INSTRUCTION, RESET_AUTHOR } from '../actions/wi_actions';
import { UPDATE_ADDED_TAGS, UPDATE_REMOVED_TAGS, UPDATE_ASSIGNED_TAGS } from '../actions/tag_actions'
import {cloneDeep} from 'lodash'
const author_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    let nextState = cloneDeep(oldState)
    switch (action.type) {
        case EDIT_WORK_INSTRUCTION:
            nextState = action.workInstruction
            return nextState
        case UPDATE_ADDED_TAGS:
            let newTags = nextState.tags
            newTags.push(...action.tags)
            nextState.tags = newTags
            return nextState
        case UPDATE_ASSIGNED_TAGS:
            nextState.tags = action.tags.reduxTags
            return nextState
        case UPDATE_REMOVED_TAGS:
            nextState.tags = nextState.tags.filter(tag => !action.tags.includes(tag._id))
            return nextState
       // case UPDATE_WORK_INSTRUCTION:
           // nextState = action.updatedWorkInstruction
          //  return nextState
        case RESET_AUTHOR:
            return {}
        default:
            return oldState;
    }
};

export default author_reducer;